// extracted by mini-css-extract-plugin
module.exports = {"container":"ve","hide":"vf","content":"vh","close":"vi","closeIcon":"vj","svgStyles":"vk"};